<template>
    <div class="login-wrap">
        <div class="head-box">补君堂互联网医疗系统</div>
        <div class="ms-login">
            <div class="ms-title">欢迎登陆</div>
            <el-form :model="Insert" :rules="rules" ref="login" label-width="0px" class="ms-content">
                <el-form-item prop="username">
                    <el-input v-model="Insert.username" clearable placeholder="请输入账号"></el-input>
                </el-form-item>
                <el-form-item prop="password">
                    <el-input clearable
                              type="password"
                              placeholder="请输入密码"
                              v-model="Insert.password"
                              @keyup.enter.native="submitForm()"
                    >
                    </el-input>
                </el-form-item>
                <div class="login-btn">
                    <el-button type="primary" @click="submitForm()">登录</el-button>
                </div>
            </el-form>
        </div>
    </div>
</template>
<script>
    export default {
        data: function () {
            return {
                rules: {
                    username: [{required: true, message: '请输入用户名', trigger: 'blur'}],
                    password: [{required: true, message: '请输入密码', trigger: 'blur'}],
                },
                param: {
                    username: '',
                    password: '',
                },
                Insert: {
                    username: '',
                    password: '',
                },
            };
        },
        methods: {

            submitForm() {
                this.$refs.login.validate(valid => {
                    if (valid) {
                        console.log(this.Insert.username)
                        event.preventDefault();
                        let params = new FormData();
                        params.append('username', this.Insert.username);
                        params.append('password', this.Insert.password);
                        this.axios.post('/10017/100000', params).then((res) => {
                            if (res.status === 200) {

                                const authorization = res.data.token_type + res.data.access_token
                                localStorage.setItem('authorization', authorization)
                                this.axios.get('/api-b/10041/100188', {
                                    headers: {
                                        Authorization: authorization
                                    }
                                }).then(res => {
                                    if(res.data.code==10000){
                                        localStorage.setItem('cardUrl', res.data.data.cardUrl);
                                        localStorage.setItem('administrativeOffice', res.data.data.administrativeOffice);
                                        localStorage.setItem('isOnline', res.data.data.isOnline);
                                    }else {
                                        localStorage.removeItem('cardUrl')
                                        localStorage.removeItem('administrativeOffice')
                                        localStorage.removeItem('isOnline')
                                    }
                                    this.axios.get('/api-b/10025/100054', {
                                        headers: {
                                            Authorization: authorization
                                        }
                                    }).then(res => {
                                        if (res.data.code === 10000) {
                                            localStorage.setItem('realName', res.data.data.realName);
                                            this.$message.success('登录成功');
                                            const menus = JSON.stringify(res.data.data.result_list);
                                            localStorage.setItem('menus', menus);

                                            localStorage.setItem('ms_username', this.Insert.username);
                                            // this.$router.push('/');
                                            const menuList = res.data.data.result_list
                                            if (menuList[0].children.length > 0) {
                                                let toPath = '/' + menuList[0].children[0].urlAddress
                                                this.$router.push(toPath);
                                            } else if (menuList[0].children.length === 0) {
                                                let toPath = '/' + menuList[0].urlAddress
                                                this.$router.push(toPath);
                                            }
                                        } else {
                                            this.$message.error('菜单获取失败,请重新登录');
                                        }
                                    }).catch(() => {

                                    })

                                }).catch(() => {

                                })


                            }
                        }).catch(() => {

                        })
                    } else {
                        this.$message.error('请输入账号和密码');
                        return false;
                    }
                });
            },
            // asyncMenu(menus) {
            //     let menuList = [
            //         {
            //             path: '/',
            //             component: () => import('@/components/common/Home.vue'),
            //             children: [],
            //         },
            //         {
            //             path: '*',
            //             redirect: '/404',
            //         }
            //     ]
            //     if (menus && menus.length>0) {
            //         for (let i=0;i<menus.length;i++) {
            //             let menu = {
            //                 path: '',
            //                 component:'',
            //                 meta: {
            //                     title: ''
            //                 }
            //             }
            //             menu.component = this.loadView(menus[i].addressUrl)
            //             menu.path = `/${menus[i].addressUrl}`
            //             menu.meta.title = menus[i].menuCaption
            //             menuList[0].children.push(menu)
            //             if (menuList[i].children.length > 0) {
            //                 for (let j=0;j<menuList[i].children.length;j++) {
            //                     let menuTwo = {
            //                         path: '',
            //                         component:'',
            //                         meta: {
            //                             title: ''
            //                         }
            //                     }
            //                     menuTwo.component = this.loadView(menuList[i].children[j].addressUrl)
            //                     menuTwo.path = `/${menuList[i].children[j].addressUrl}`
            //                     menuTwo.meta.title = menuList[i].children[j].menuCaption
            //                     menuList[0].children.push(menuTwo)
            //                 }
            //             }
            //         }
            //     }
            //     return menuList
            // },
            // loadView(view) {
            //     // 路由懒加载
            //     return () => import(`@/components/page/${view}`);
            // }
        },
    };
</script>

<style scoped>
    .head-box {
        position: relative;
        top: -60px;
        width: 100%;
        height: 60px;
        padding: 20px;
        font-size: 16px;
    }

    .login-wrap {
        position: relative;
        top: 60px;
        width: 100%;
        height: 100%;
        background-image: url(../../assets/img/login.png);
        background-color: #EEEEEE;
    }

    .ms-title {
        margin: 57px 157px 20px 157px;
        width: 72px;
        height: 25px;
        font-size: 18px;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        line-height: 25px;
    }

    .ms-login {
        position: absolute;
        left: 50%;
        top: 50%;
        width: 386px;
        margin: -236px 0 0 -193px;
        border-radius: 8px;
        background: rgba(255, 255, 255, 1);
        overflow: hidden;
    }

    .ms-content {
        padding: 0 51px;
    }

    .login-btn {
        text-align: center;
    }

    .login-btn button {
        width: 100%;
        height: 36px;
        margin-bottom: 70px;
    }

</style>